import user from './user.js'
import index from './index.js'
import system from './system.js'

export default {
	user: user,
  index: index,
  system: system
}



// WEBPACK FOOTER //
// ./src/api/api.js